import { render } from "./App.vue?vue&type=template&id=5ee777ef"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5ee777ef&lang=css"

import exportComponent from "/home/entheo/wetouch2_bce_2022/site_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__